import styles from './Footer.module.css';
import FacebookLogo from './SocialMediaIcons/facebook.png';
import XLogo from './SocialMediaIcons/twitter.png';
import InstagramLogo from './SocialMediaIcons/instagram.png';

const Footer = ({ className }) => {
    return (
        <footer className={`${styles.footer} ${className || ''}`}>
            <div className={styles.footerColumn}>
                <h3>Llámanos</h3>
                <p>(442) 2385-000</p>
            </div>
            <div className={styles.footerColumn}>
                <h3>Envíanos un correo</h3>
                <p>
                    <a href="mailto:tucareraaa@queretaro.gob.mx">jequintana@queretaro.gob.mx </a>
                </p>
                <div className={styles.socialIcons}>
                    <a href="https://www.facebook.com/educacionqro" target="_blank" rel="noopener noreferrer">
                        <img src={FacebookLogo} alt="Fb" className={styles.socialIcon} />
                    </a>
                    <a href="https://x.com/educacionqro" target="_blank" rel="noopener noreferrer">
                        <img src={XLogo} alt="Twitter" className={styles.socialIcon} />
                    </a>
                    <a href="https://www.instagram.com/educacionqueretaro/" target="_blank" rel="noopener noreferrer">
                        <img src={InstagramLogo} alt="Instagram" className={styles.socialIcon} />
                    </a>
                </div>
            </div>
            <div className={styles.footerColumn}>
                <h3>Visítanos</h3>
                <p>Av. Prolongación Luis Pasteur #23 Centro Histórico. Querétaro 76000</p>
            </div>
        </footer>
    );
};

export default Footer;